"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.receiveMessages = void 0;
var index_1 = require("../index");
var calculatePlaybackRate_1 = require("./calculatePlaybackRate");
var config_1 = require("../config");
var enum_1 = require("../enum");
var calculatePlaybackProgramDate_1 = require("./calculatePlaybackProgramDate");
var onChangeGroupVolume = function (info) {
    var volume = info.message.data.volume;
    info.client.setVolume(volume);
};
var muteCurrentGroup = function (info) {
    info.client.mute();
};
var onPauseGroup = function (info) {
    info.client.pause();
};
var onPlayGroup = function (info) {
    info.client.play();
};
var handleGroupEvent = function (info) {
    if (info.callback) {
        info.callback(index_1.Callbacks.receive_command, [info.message]);
    }
};
var onChatMessageReceive = function (chatMessageInfo) {
    if (chatMessageInfo.callback) {
        chatMessageInfo.callback(index_1.Callbacks.chat_update, [
            {
                clientName: chatMessageInfo.message.data.name,
                message: chatMessageInfo.message.data.message,
                ownMessage: chatMessageInfo.ownMessage
            }
        ]);
    }
};
var receiveClientList = function (clientListInfo) {
    if (clientListInfo.callback) {
        clientListInfo.callback(index_1.Callbacks.client_list_update, [{ clientList: clientListInfo.message.data.clientList }]);
    }
};
var synchronizeClient = function (syncInfo) {
    if (syncInfo.rememberedPosition !== false) {
        var _a = calculatePlaybackProgramDate_1.default(syncInfo.message.data.data.timestamp, syncInfo.message.data.data.position, syncInfo.client, syncInfo.message.streamOffset, syncInfo.message.serverTimeDelay, syncInfo.rememberedPosition), speed = _a.speed, delta = _a.delta;
        syncInfo.client.changePlaybackRate(speed);
        syncInfo.callback(index_1.Callbacks.speed_change, [speed]);
        return { speed: speed, delta: delta };
    }
    else {
        var _b = calculatePlaybackRate_1.default(syncInfo.message.data.data.timestamp, syncInfo.message.data.data.position, syncInfo.client, syncInfo.message.streamOffset, syncInfo.message.serverTimeDelay), speed = _b.speed, delta = _b.delta;
        syncInfo.client.changePlaybackRate(speed);
        syncInfo.callback(index_1.Callbacks.speed_change, [speed]);
        return { speed: speed, delta: delta };
    }
};
var syncProgress = function (syncInfo) {
    if (syncInfo.rememberedPosition !== false) {
        var _a = calculatePlaybackProgramDate_1.default(syncInfo.message.data.data.timestamp, syncInfo.message.data.data.position, syncInfo.client, syncInfo.message.streamOffset, syncInfo.message.serverTimeDelay, syncInfo.rememberedPosition), speed = _a.speed, delta = _a.delta;
        if (Math.abs(delta) < config_1.default.minDelta) {
            syncInfo.client.changePlaybackRate(speed);
            syncInfo.callback(index_1.Callbacks.speed_change, [speed]);
            syncInfo.callback(index_1.Callbacks.delta_change, [delta]);
            return { delta: delta, speed: speed };
        }
        return null;
    }
    else {
        var _b = calculatePlaybackRate_1.default(syncInfo.message.data.data.timestamp, syncInfo.message.data.data.position, syncInfo.client, syncInfo.message.streamOffset, syncInfo.message.serverTimeDelay), speed = _b.speed, delta = _b.delta;
        if (Math.abs(delta) < config_1.default.minDelta) {
            syncInfo.client.changePlaybackRate(speed);
            syncInfo.callback(index_1.Callbacks.speed_change, [speed]);
            syncInfo.callback(index_1.Callbacks.delta_change, [delta]);
            return { delta: delta, speed: speed };
        }
        return null;
    }
};
exports.receiveMessages = (_a = {},
    _a[enum_1.IncomeMessage.change_group_volume] = onChangeGroupVolume,
    _a[enum_1.IncomeMessage.sync_group_pause] = onPauseGroup,
    _a[enum_1.IncomeMessage.sync_group_play] = onPlayGroup,
    _a[enum_1.IncomeMessage.chat_message] = onChatMessageReceive,
    _a[enum_1.IncomeMessage.client_list] = receiveClientList,
    _a[enum_1.IncomeMessage.synchronize] = synchronizeClient,
    _a[enum_1.IncomeMessage.sync_progress] = syncProgress,
    _a[enum_1.IncomeMessage.mute_group] = muteCurrentGroup,
    _a[enum_1.IncomeMessage.event_to_group] = handleGroupEvent,
    _a);
//# sourceMappingURL=messageHandler.js.map